export const chat2_16 = [
	{
		"user": "greatlover05",
		"message": "bei all dem geilen Fickmaterial hier kann mann sich ja gar nicht entscheiden ;-)",
		"time": "00:02"
	},
	{
		"user": "{f_model1}",
		"message": "ich hab schon angefangen mich auszuziehen, bumblebee. Jetzt hab ich nur noch meine schwarzen Spitzendessous für dich an! Was soll ich jetzt tun Süßer?",
		"time": "00:07"
	},
	{
		"user": "{f_model2}",
		"message": "na klar bekommst du mein Hinterteil zu sehen! Den zeig ich doch gerne her! ;-) Bittesehr {ass_pic}",
		"time": "00:15"
	},
	{
		"user": "Gast348",
		"message": "kann man euch auch in echt ficken????",
		"time": "00:19"
	},
	{
		"user": "bumblebee",
		"message": "pack deine geilen Hupen für mich aus {f_model1}. Damit ich mein Gesicht darin vergraben kann!!",
		"time": "00:25"
	},
	{
		"user": "Gast178",
		"message": "@{f_model2}: das is ma ein heißes geschoss! ich bekomm schon nen ganz harten! wo kann ich den in action sehn?",
		"time": "00:31"
	},
	{
		"user": "{m_model1}",
		"message": "Gibt es hier auch Jungs für Jungs? :-P",
		"time": "00:36"
	},
	{
		"user": "cocky",
		"message": "ich sehen will nackte Haut. Welche zeigen mir?",
		"time": "00:40"
	},
	{
		"user": "{f_model3}",
		"message": "Huhuuu! Ist hier noch ein netter Kerl frei, der mir die Zeit versüßen will? Sitze ganz alleine vor meiner Cam und bin schon ein bisschen feucht *gg*",
		"time": "00:46"
	},
	{
		"user": "{f_model1}",
		"message": "oh ja, dein Gesicht würde hier wunderbar dazwischen passen bumblebee. Und nicht nur das :-P {tits_pic}",
		"time": "00:51"
	},
	{
		"user": "{m_model2}",
		"message": "dachte schon es fragt keiner mehr :-D Nichts gegen euch Mädels, aber ich steh mehr auf gut gebaute Männer ;-) {m_model1}, wollen wir und näher kennenlernen?",
		"time": "00:55"
	},
	{
		"user": "{f_model2}",
		"message": "@Gast178: du willst meinen Hintern wackeln sehen? ;-) so in etwa? {video}",
		"time": "01:02"
	},
	{
		"user": "DonPedro",
		"message": "@{f_model3}: JA! HIER! Ich! :-D Wo finde ich denn deine Cam???",
		"time": "01:10"
	},
	{
		"user": "bumblebee",
		"message": "rrrrr…die sind ja mega! Ja, da würde ich auch meinen Schwanz gerne mal dazwischenpacken….definitiv!! :-D",
		"time": "01:16"
	},
	{
		"user": "{m_model1}",
		"message": "klasse, dachte schon ich bin hier falsch, aber du schaust schon mal gaaar nicht schlecht aus :-D wo finde ich dich denn du knackiger Kerl?",
		"time": "01:20"
	},
	{
		"user": "{f_model3}",
		"message": "@DonPedro: {profile_link} beeil dich!! Meine Mumu braucht jetzt dringend einen richtig schön harten Schwanz der es ihr besorgt",
		"time": "01:26"
	},
	{
		"user": "{f_model1}",
		"message": "oh ja und wenn sie dann fertig mit deinem besten Stück sind dann darfst du die volle Ladung schön geil auf sie verteilen. Mhhhhh….",
		"time": "01:32"
	},
	{
		"user": "{f_model4}",
		"message": "Hey Jungs! Bin neu hier und suche einen richtigen Mann der mir hier zeigt wos langgeht. Kein Weichei bitte!! Zeig mich einfach mal {video}",
		"time": "01:38"
	},
	{
		"user": "Gast178",
		"message": "geil, {f_model2}! Ich steh total auf pralle Hintern! Darf man den da auch reinstecken bei dir? ;-)",
		"time": "01:42"
	},
	{
		"user": "DonPedro",
		"message": "ich komme Süße! geh nicht weg!! Ich melde mich nur schnell an...",
		"time": "01:49"
	},
	{
		"user": "{m_model2}",
		"message": "am besten du kommst in meine Cam. Da lässt es sich besser beschnuppern :-D {profile_link}",
		"time": "01:55"
	},
	{
		"user": "{f_model5}",
		"message": "{hard_pic}",
		"time": "02:01"
	},
	{
		"user": "HerrundMeister",
		"message": "@{f_model4}: Da bist du bei mir genau richtig. Ich weiß, was gut für dich ist! Mach was ich sage und wir werden uns gut verstehen!",
		"time": "02:08"
	},
	{
		"user": "bumblebee",
		"message": "langsam regt sich bei mir in der Hose ganz schön was :-D Können wir uns irgendwo ungestört weiter unterhalten?",
		"time": "02:15"
	},
	{
		"user": "{f_model2}",
		"message": "@Gast178: meine Löcher stehen dir alle mehr als gerne zur Verfügung. Du darfst dir eins aussuchen :-P Schön eng und feucht…welches ist deinem Schwanz denn am liebsten Süßer?",
		"time": "02:22"
	},
	{
		"user": "{f_model4}",
		"message": "Ich stehe ganz zu deiner Verfügung mein HerrundMeister! Sag mir, was ich für dich tun soll und ich tue es.",
		"time": "02:29"
	},
	{
		"user": "{f_model1}",
		"message": "ich schalte meine Kamera für dich an {profile_link} Hast du auch eine?",
		"time": "02:38"
	},
	{
		"user": "{f_model6}",
		"message": "{profile_pic} Hallo ihr Süßen!",
		"time": "02:44"
	},
	{
		"user": "Gast348",
		"message": "Wer von euch will denn nun mal so richtig durchgefickt werden?",
		"time": "02:50"
	},
	{
		"user": "Kevin30",
		"message": "Hallo {f_model6}",
		"time": "02:58"
	}
]
